import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { convertFromRaw, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const createStrategy = (tag) => (contentBlock, callback, contentState) => {
  return contentBlock.findEntityRanges((char) => {
    const entityKey = char.getEntity();
    return (
      entityKey !== null && contentState.getEntity(entityKey).getType() === tag
    );
  }, callback);
};
const decorators = [
  {
    strategy: createStrategy('VIDEO'),
    component: (props) => {
      const entityData = props.contentState
        .getEntity(props.entityKey)
        .getData();
      return (
        <video
          src={entityData.src}
          controls={entityData.controls}
          style={{ maxWidth: '100%' }}
        />
      );
    },
  },
  {
    strategy: createStrategy('AUDIO'),
    component: (props) => {
      const entityData = props.contentState
        .getEntity(props.entityKey)
        .getData();
      return (
        <audio
          src={entityData.src}
          controls={entityData.controls}
          style={{ maxWidth: '100%' }}
        />
      );
    },
  },
];

class DraftDisplay extends Component {
  static propTypes = {
    editorObject: PropTypes.object,
  };

  render() {
    return (
      <Editor
        editorState={EditorState.createWithContent(
          convertFromRaw(this.props.editorObject)
        )}
        readOnly={true}
        toolbarHidden={true}
        customDecorators={decorators}
        toolbar={{ link: { showOpenOptionOnHover: false } }}
      />
    );
  }
}

export default DraftDisplay;
